import teamRequestModalRemoveComponent from './teamRequestModalRemove.component';
import teamRequestModalRemoveQuestion from './teamRequestModalRemoveQuestion/teamRequestModalRemoveQuestion';

let teamRequestModalRemoveModule = angular.module('vacations-absences.teamRequestModalRemove', [
  teamRequestModalRemoveQuestion
])

.component('teamRequestModalRemove', teamRequestModalRemoveComponent)

.name;

export default teamRequestModalRemoveModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestModalRemove/teamRequestModalRemove.js